/* ============================================================
   HimalayaEcho · Wishlist + Recently Viewed（M4 · 2026-06-11）
   localStorage 轻量实现，无 App。
   - he_wishlist: [handle, ...]
   - he_recent:   [handle, ...] 上限 12
   钩子：
   - 按钮 [data-he-wish][data-handle]
   - header 计数 .he-wish-count
   - 收藏页网格 [data-he-wish-grid]（支持 ?items= 分享）
   - 最近浏览条 [data-he-recent]
   ============================================================ */
(function () {
  'use strict';
  var WKEY = 'he_wishlist';
  var RKEY = 'he_recent';

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function write(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* private mode */ }
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.querySelector('.he-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'he-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2200);
  }

  /* ---------- state sync ---------- */
  function updateBadges() {
    var n = read(WKEY).length;
    document.querySelectorAll('.he-wish-count').forEach(function (b) {
      b.textContent = n;
      b.classList.toggle('is-hidden', n === 0);
    });
  }
  function syncButtons(root) {
    var list = read(WKEY);
    (root || document).querySelectorAll('[data-he-wish]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-handle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function toggle(handle) {
    var list = read(WKEY);
    var i = list.indexOf(handle);
    if (i === -1) {
      list.unshift(handle);
      toast('Saved to your wishlist ♡');
    } else {
      list.splice(i, 1);
      toast('Removed from your wishlist');
    }
    write(WKEY, list);
    updateBadges();
    syncButtons();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-he-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
  });

  /* ---------- recently viewed recorder ---------- */
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (m) {
    var h = decodeURIComponent(m[1]);
    var recent = read(RKEY).filter(function (x) { return x !== h; });
    recent.unshift(h);
    write(RKEY, recent.slice(0, 12));
  }

  /* ---------- client renderers ---------- */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function attrEsc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
  function cardHTML(p, removable) {
    var img = p.featured_image
      ? '<img src="' + p.featured_image + '&width=420" loading="lazy" alt="' + attrEsc(p.title) + '">'
          .replace('&width', p.featured_image.indexOf('?') === -1 ? '?width' : '&width')
      : '';
    return (
      '<div class="he-mini-card">' +
        '<a class="he-mini-card__link" href="/products/' + p.handle + '">' +
          '<span class="he-mini-card__media">' + img + '</span>' +
          '<span class="he-mini-card__title">' + attrEsc(p.title) + '</span>' +
          '<span class="he-mini-card__price">' + money(p.price) + '</span>' +
        '</a>' +
        (removable
          ? '<button type="button" class="he-mini-card__remove" data-he-wish data-handle="' + p.handle + '" aria-label="Remove from wishlist">✕</button>'
          : '') +
      '</div>'
    );
  }
  function fetchProducts(handles) {
    return Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : { __dead: h }; })
          .catch(function () { return null; });
      })
    ).then(function (list) {
      /* 404(下架/删除)的 handle 从 localStorage 剔除,badge 才不虚高;网络失败(null)不剔(2026-07-08 审计) */
      var dead = list.filter(function (x) { return x && x.__dead; }).map(function (x) { return x.__dead; });
      if (dead.length) {
        var kept = read(WKEY).filter(function (h) { return dead.indexOf(h) === -1; });
        write(WKEY, kept); updateBadges();
      }
      return list.filter(function (x) { return x && !x.__dead; });
    });
  }

  function renderRecent() {
    var el = document.querySelector('[data-he-recent]');
    if (!el) return;
    var current = m ? decodeURIComponent(m[1]) : null;
    var handles = read(RKEY).filter(function (x) { return x !== current; }).slice(0, 8);
    var sectionWrap = el.closest('.he-strip-section');
    if (!handles.length) { if (sectionWrap) sectionWrap.hidden = true; return; }
    fetchProducts(handles).then(function (list) {
      if (!list.length) { if (sectionWrap) sectionWrap.hidden = true; return; }
      el.innerHTML = list.map(function (p) { return cardHTML(p, false); }).join('');
      if (sectionWrap) sectionWrap.hidden = false;
    });
  }

  function renderWishGrid() {
    var el = document.querySelector('[data-he-wish-grid]');
    if (!el) return;
    var params = new URLSearchParams(location.search);
    var shared = params.get('items');
    var handles = shared ? shared.split(',').filter(Boolean).slice(0, 40) : read(WKEY);
    var emptyEl = document.querySelector('[data-he-wish-empty]');
    var sharedNote = document.querySelector('[data-he-wish-shared-note]');
    if (shared && sharedNote) sharedNote.hidden = false;
    if (!handles.length) {
      if (emptyEl) emptyEl.hidden = false;
      el.innerHTML = '';
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    fetchProducts(handles).then(function (list) {
      el.innerHTML = list.map(function (p) { return cardHTML(p, !shared); }).join('');
      syncButtons(el);
    });
  }

  /* share: copy link with ?items= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-he-wish-share]');
    if (!btn) return;
    var list = read(WKEY);
    if (!list.length) { toast('Your wishlist is empty'); return; }
    var url = location.origin + location.pathname + '?items=' + list.join(',');
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject())
      .then(function () { toast('Wishlist link copied. Share it as a hint 🎁'); })
      .catch(function () { window.prompt('Copy your wishlist link:', url); });
  });

  /* wishlist 变化时刷新收藏页网格 */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-he-wish]') && document.querySelector('[data-he-wish-grid]')) {
      setTimeout(renderWishGrid, 60);
    }
  });

  /* S&D 筛选/分页会重渲染产品网格 → 观察新增按钮并同步状态 */
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { syncButtons(); break; }
    }
  });

  function init() {
    updateBadges();
    syncButtons();
    renderRecent();
    renderWishGrid();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
